import React from 'react';

export default class Inventory extends React.Component {
	render() {
		return null;
	}
}
